<template>
    <b-container fluid>
        <b-row>
            <b-col cols="4">
                <b-btn variant="primary" block  @click="openModalCreateDoor"
                    ><i class="fa fa-plus"></i> Crear puerta</b-btn
                >
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <app-door-filters
                    @filter="onFilter"
                    :the-client="currentClient"
                ></app-door-filters>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <app-data-table
                    v-if="!!tableData"
                    :fields="fields"
                    :items="tableData.data"
                    :current-page="tableData.current_page"
                    :last-page="tableData.last_page"
                    :from="tableData.from"
                    :to="tableData.to"
                    :total="tableData.total"
                    :per-page="tableData.per_page"
                >
                    <template #created_at="{ item }">
                        {{ item.created_at | datetime }}
                    </template>
                    <template #actions="{ item }">
                        <b-btn
                            @click="openModalDoorAssignment(item)"
                            variant="success"
                            size="sm"
                            ><i class="fa fa-users"></i
                        ></b-btn>
                        <b-btn variant="primary" size="sm" @click="openModalToEditDoor(item)"
                            ><i class="fa fa-edit"></i
                        ></b-btn>
                        <b-button variant="danger" size="sm" @click="startDelete(item.id)"
                            ><i class="fa fa-trash"></i
                        ></b-button>
                    </template>
                </app-data-table>
            </b-col>
        </b-row>
        <!-- Início popups --------------------------->
        <app-pop-up
            id="door-form-window"
            title="Formulario creación de puertas"
        >
            <template slot="body">
                <app-door-form
                ref="doorForm"
                @saved-door="onSavedDoor"
                ></app-door-form>
            </template>
            <template slot="buttons">
                <b-btn
                    id="btnSaveDoor"
                    variant="primary"
                    @click="onSaveDoor"
                    :disabled="inProgress"
                    ><i class="fa fa-save"></i> Guardar</b-btn>
            </template>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="door-remove-window">
            <div slot="body"><h2>¿Esta seguro que desea eliminar la puerta?</h2></div>
            <div class="buttons" slot="buttons">
                <b-btn variant="confirm" @click="deleteDoor()"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</b-btn>
            </div>
        </app-pop-up>

        <app-pop-up
            id="door-assignment-form-window"
            size="large"
            :onClose="cleanForm"
        >
            <template slot="body">
                <app-door-assignment
                @assigned-people="onAssignedPeople"
                :the-door="currentDoor"
                ref="doorAssignment"
                ></app-door-assignment>
            </template>
            <template slot="buttons">
                <b-btn
                    id="btnDoorAssignment"
                    variant="primary"
                    @click="onAssignmentDoor"
                    :disabled="inProgress"
                    ><i class="fa fa-save"></i> Asignar</b-btn>
            </template>
        </app-pop-up>
    </b-container>
</template>
<script>
import appDoorFilters from './DoorFilters'
import appDoorForm from './DoorForm'
import appDoorAssignment from './DoorAssignment'
export default {
    components: {
        appDoorFilters,
        appDoorForm,
        appDoorAssignment
    },
    props: {
        theClient: {
            type: Object,
        },
    },
    data: () => ({
        tableData: null,
        filters: null,
        fields,
        page: 1,
        sortBy: 'created_at',
        sortDir: 'desc',
        currentClient: '',
        currentDoorId: '',
        currentDoor: {}
    }),
    computed: {
        theFilters() {
            var objectClient = {}
            objectClient = {
                    ...this.filters,
                    page: this.page,
                    sortBy: this.sortBy,
                    sortDir: this.sortDir,
                    with: 'structure.venue',
                }
            if(!!this.theClient){
                objectClient['clientId'] = this.theClient.id
                this.currentClient = this.theClient
            }else{
                objectClient['clientId'] = this.client.id
                this.currentClient = this.client
            }
            return objectClient
        },
    },
    methods: {
        onAssignedPeople(data){
            toastr.success(data.msg)
            this.$bus.$emit('door-assignment-form-window.close');
        },
        openModalDoorAssignment(door){
            this.currentDoor = door
            this.$bus.$emit('door-assignment-form-window.open');
            this.$refs.doorAssignment.loadPeopleAssigned(door)
        },
        onAssignmentDoor(){
            this.$refs.doorAssignment.assignPeople()
        },
        startDelete(doorId){
            this.currentDoorId = doorId
            this.$bus.$emit('door-remove-window.open');
        },
        async openModalToEditDoor(door){
            this.$refs.doorForm.fill(door);
            this.$bus.$emit("door-form-window.open");
        },
        onSavedDoor(data){
            toastr.success(data.msg)
            this.$bus.$emit("door-form-window.close");
            this.loadDoors()
        },
        async loadDoors() {
            const { data } = await repo.get('doors', this.theFilters)
            this.tableData = data
        },
        onFilter(filters) {
            this.filters = filters
            this.loadDoors()
        },
        openModalCreateDoor() {
            this.$refs.doorForm.reset();
            this.$bus.$emit("door-form-window.open");
        },
        onSaveDoor(){
            this.$refs.doorForm.saveDoor();
        },
        async deleteDoor()
        {
            const {data} = await repo.delete(`doors/${this.currentDoorId}`)
            if(data.status){
                toastr.success(data.msg)
                this.$bus.$emit('door-remove-window.close');
                this.loadDoors()
            }else{
                return toastr.error('No se pudo eliminar la puerta')
            }
        },
        cleanForm(){
            this.$refs.doorAssignment.onChangePage(1);
        }

    },
    created() {
        this.loadDoors()
    },
}

const fields = [
    {
        key: 'id',
        label: 'ID',
    },
    {
        key: 'name',
        label: 'Puerta',
    },
    {
        key: 'structure.venue.name',
        label: 'Sede',
    },
    {
        key: 'structure.name',
        label: 'Puesto',
    },
    {
        key: 'level',
        label: 'Nivel',
    },
    {
        key: 'description',
        label: 'Descripción',
    },
    {
        key: 'created_at',
        label: 'Fecha de creación',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
